import { EQueryStringActionType, TSetQueryString } from './types';

export function setQueryString(queryString: string): TSetQueryString {
  return {
    type: EQueryStringActionType.SetQueryString,
    payload: queryString,
  };
}
